import React, { ReactNode } from 'react';
import styled from 'styled-components';

const SROnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

interface KitSROnlyProps {
  children: ReactNode;
  id?: string;
  className?: string;
}

const KitSROnly: React.FC<KitSROnlyProps> = ({
  id,
  children,
  className,
  ...rest
}: KitSROnlyProps) => {
  return (
    <SROnly id={id} className={className} {...rest}>
      {children}
    </SROnly>
  );
};

export default KitSROnly;
